export default __webpack_public_path__ + "static/media/resume.2a71aabc.jpeg";